import React from 'react';
import { Button } from 'ui-toolkit/index';
import { TaxYearInformation } from './TaxYearInformation';
import {
  createDefaultTaxYearInformationData,
  ITaxYearInformationData,
} from 'ui-toolkit/taxCertifications/ITaxYearInformation';
import { Field, FieldArray } from 'formik';
import { IJurisdictionData } from 'ui-toolkit/taxCertifications/IJurisdiction';
import { NewOrderSpaceWrapping } from '../../orderCreation/wrappers/NewOrderSpaceWrapper';
import { IFieldChildProps } from '../../../ui-toolkit/utilities/formikUtilities';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

export interface ITaxYearInformationsProps {
  baseName: string;
}

export const TaxYearInformations: React.FC<ITaxYearInformationsProps> = ({ baseName }) => {
  return (
    <Field name={baseName}>
      {({ field }: IFieldChildProps<ITaxYearInformationData[], IJurisdictionData>) => (
        <FieldArray name={baseName}>
          {({ remove, push }) => (
            <>
              {field.value.map((item, index) => (
                <TaxYearInformation
                  key={`taxYearInformation.${item.id}`}
                  baseName={`${baseName}.${index}`}
                  index={index}
                  onRemove={() => remove(index)}
                  canDelete={field.value.length > 1}
                />
              ))}
              <NewOrderSpaceWrapping>
                <Button
                  intent="secondary"
                  type={'button'}
                  onClick={() => push(createDefaultTaxYearInformationData())}
                  data-test-id={mergeTests(baseName, `add`)}
                >
                  + Add Tax Year Information
                </Button>
              </NewOrderSpaceWrapping>
            </>
          )}
        </FieldArray>
      )}
    </Field>
  );
};
